export default {
    getIsLoggedIn(state) {
      return state.isLoggedIn;
    },
};
